import Navbar from '@/pages/home/components/Navbar';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoriesSection from '@/pages/home/components/CategoriesSection';
import StatsSection from '@/pages/home/components/StatsSection';
import SeoBlogSection from '@/pages/home/components/SeoBlogSection';
import ContentSection from '@/pages/home/components/ContentSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <StatsSection />
        <SeoBlogSection />
        <ContentSection />
      </main>
      <Footer />
    </div>
  );
}